import { Icon } from '@chakra-ui/react';

export const FillCloseCircle = (props) => (
  <Icon viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M9 18C4.029 18 0 13.971 0 9C0 4.029 4.029 0 9 0C13.971 0 18 4.029 18 9C18 13.971 13.971 18 9 18Z"
      fill="#FF5454"
      fillOpacity="0.08"
    />
    <path
      d="M11.83 6.16992L6.17004 11.8299"
      stroke="#FF5454"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.83 11.8299L6.17004 6.16992"
      stroke="#FF5454"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
